import type { IOrderServices } from '~/processes/providers/authorization';
import type { IServiceWithColor } from '../entity';

export class ServicesList {
    private servicesDto: IOrderServices[];
    private services: IServiceWithColor[] = [];

    constructor (servicesDto: IOrderServices[]) {
        this.servicesDto = servicesDto;
    }

    private _initServices() {
        this.services = this.servicesDto.map((service) => ({
            ...service,
            colored: false,
        }));
    }

    private _addColored() {
        let colored = false;

        const result = this.services.map((service) => {
            if (service.parent_id.length === 0) {
                colored = !colored;
            }

            return {
                ...service,
                colored,
            };
        });

        this.services = result;
    }

    private _sortByParent() {
        let unsortedServices = this.services;
        const result: IServiceWithColor[] = [];
        const withParentServices = unsortedServices.filter((service) => service.parent_id.length > 0);
        const parentIds = new Set(withParentServices.map((service) => service.parent_id));

        parentIds.forEach((parentId) => {
            const parentService = unsortedServices.find((service) => String(service.dos_id) === parentId);
            if (parentService) {
                result.push(parentService);
                unsortedServices = unsortedServices.filter((service) => service.dos_id !== parentService.dos_id);
                const children = unsortedServices.filter((service) => service.parent_id === String(parentService.dos_id));
                children.forEach(child => {
                    result.push(child);
                    unsortedServices = unsortedServices.filter((service) => service.dos_id !== child.dos_id);
                });
            }
        });

        this.services = result.concat(unsortedServices);
    }

    public get(): IServiceWithColor[] {
        this._initServices(),
        this._sortByParent();
        this._addColored();
        return this.services;
    }
}
